import React from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

const NavigationBar = () => {
  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Link to="/">
          <Navbar.Brand>Movies</Navbar.Brand>
        </Link>
        <Link to="/favoriteFilm">
          <Navbar.Brand>Favorite</Navbar.Brand>
        </Link>
      </Navbar>
    </>
  );
};

export default NavigationBar;
